export const APNS2_SETTINGS = {
  environment: "production",
  topic: "com.marigold.cleanslate",
};
